import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'help_center-order_skip-click';

/**
 * It&#39;s the skip button click event, when the customer sees the order selection page during self-serve flow in the help center. It capture which page they are
 */
export function trackHelpCenterOrderSkipClick(
  retailerToken: string,
  brandToken: string,
  url: string,
  issue_type2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { retailerToken, brandToken, url, issue_type2 },
  });
}
